import dynamic from 'next/dynamic';

export const ChangeBillingAddressModalDynamic = dynamic(
  () =>
    import('./ChangeBillingAddressModal.client').then((mod) => ({
      default: mod.ChangeBillingAddressModal,
    })),
  { ssr: false },
);
